import { passengerTypeAction } from "../../../../Actions/Index";
import { saveCompanionAction } from "../../../../Actions/LogicActions/MyAccount/CompanionSetting/SaveCompanionAction";
import { _eventBus } from "../../../../core/events/EventBus";
import { StepDefinition } from "../../../../core/flows/StepDefinition";
import { StepFlow } from "../../../../core/flows/StepFlow";
import { myAccountTree } from "../../../../Orchestrator/ConstantTree";
import { updateRecoilState } from "../../../../Orchestrator/Recoils/Events/Recoil";
import { showNotification } from "../../../../Services/notificationService";

export class CompanionSettingInitStep extends StepFlow {
  get stepName() { return "CompanionSettingInit_Step"; }

  async onEventSetup(): Promise<void> {
    this.registerEventSubscription(
      _eventBus.on({
        eventName: myAccountTree.companionSetting.form.Init,
        handler: async () => {
          await passengerTypeAction.execute();
          if (passengerTypeAction.result?.length) {
            updateRecoilState("passengerTypesStateAtom", passengerTypeAction.result);
          }
        }
      })
    )

    this.registerEventSubscription(
      _eventBus.on({
        eventName: myAccountTree.companionSetting.form.Add,
        handler: async (data: any) => {
          const { userId, existingPassengers, newPassenger } = data?.data || {};

          let newPassengerList = [...(existingPassengers || []), {
            ...newPassenger,
            ...(newPassenger?.birthdate && { birthdate: newPassenger.birthdate?.format("YYYY-MM-DD") })
          }];

          saveCompanionAction.setParams({
            userId,
            companionList: newPassengerList
          });
          await saveCompanionAction.execute();

          if (saveCompanionAction.result) {
            // showNotification("success", "Companion added successfully.", "");
            showNotification("success", data?.data?.intl.formatMessage({ id: "companionAdded" }), data?.data?.intl.formatMessage({ id: "addCompanionBook" }));
          }
        }
      })
    )

    this.registerEventSubscription(
      _eventBus.on({
        eventName: myAccountTree.companionSetting.form.Update,
        handler: async (data: any) => {
          const { userId, existingPassengers, updatedPassenger, index } = data?.data || {};

          let updatedPassengerList = [...(existingPassengers || [])];
          const { isSelected: _isSelected, birthdate: _existingBirthdate, ...existingFields } = updatedPassengerList[index] ?? {};
          const { birthdate, ...formFields } = updatedPassenger ?? {};
          updatedPassengerList[index] = {
            ...existingFields,
            ...formFields,
            ...(birthdate && { birthdate: birthdate.format("YYYY-MM-DD") }),
          };

          saveCompanionAction.setParams({
            userId,
            companionList: updatedPassengerList
          });
          await saveCompanionAction.execute();

          if (saveCompanionAction.result) {
            showNotification("success", "Companion updated successfully.", "");
          }
        }
      })
    )

    this.registerEventSubscription(
      _eventBus.on({
        eventName: myAccountTree.companionSetting.form.Delete,
        handler: async (data: any) => {
          const { userId, newPassengerList } = data?.data || {};

          saveCompanionAction.setParams({
            userId,
            companionList: newPassengerList,
          });
          await saveCompanionAction.execute();

          if (saveCompanionAction.result) {
            // showNotification("info", "Companion deleted successfully.", "");
            showNotification("info", data?.data?.intl.formatMessage({ id: "companionDeleted" }), "");
          }
        },
      })
    )

    this.registerEventSubscription(
      _eventBus.on({
        eventName: myAccountTree.exitStep,
        handler: () => {
          this.next();
        }
      })
    )
  }

  async onExecute(): Promise<void> {
    console.log("Companion Setting Page Initialize.....")
    await passengerTypeAction.execute();
    if (passengerTypeAction.result?.length) {
      updateRecoilState("passengerTypesStateAtom", passengerTypeAction.result);
    }
  }
}

export const CompanionSettingInitStepDeclaration = new StepDefinition({
  stepName: "CompanionSettingInit_Step",
  stepClass: CompanionSettingInitStep,
})